<template>
  <div>
    <div
      class="card table-container mb-4"
      v-for="taskFamily in Object.keys(groupedTasks)"
      :key="taskFamily"
    >
      <div class="card-header border-0">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="mb-0">
              <i class="fas fa-chart-bar pt-2 mr-2"></i>
              {{ familyLabels[taskFamily] || taskFamily }}
              <span class="text-sm float-right mt-2"
                ><i class="ni ni-tag mr-1"></i> {{ taskFamily }}</span
              >
            </h4>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <base-table
          class="table align-items-center table-flush"
          thead-classes="thead-light"
          tbody-classes="list"
          :data="groupedTasks[taskFamily]"
        >
          <template slot="columns">
            <th>#</th>
            <th>Data de início da tarefa</th>
            <th>Data limite da tarefa</th>
            <th>Resposta da startup</th>
          </template>
          <template slot-scope="{ row, index }">
            <td>{{ index + 1 }}</td>
            <td>
              {{ formatDate(row.start_date) }}
            </td>
            <td>
              {{ row.deadline ? formatDate(row.deadline) : "N/A" }}
            </td>
            <td
              :title="
                row.responses[0]
                  ? `Última atualização ${formatDate(
                      row.responses[0].updated_at,
                      'L'
                    )}`
                  : 'A startup ainda não respondeu a tarefa'
              "
            >
              <span v-if="row.responses[0]" class="font-weight-bold">{{
                row.responses[0].answer_number
              }}</span>
              <span v-else>N/A</span>
            </td>
          </template>
        </base-table>
      </div>
    </div>
    <div
      v-if="!Object.keys(groupedTasks).length"
      class="text-warning text-center"
    >
      Não há agrupamentos compatíveis
    </div>
  </div>
</template>
<script>
export default {
  name: "task-family-table",
  props: {
    tasks: {
      type: Array,
      default: () => [],
      description: "Table data (tasks array)",
    },
  },
  data() {
    return {
      groupedTasks: {},
      familyLabels: {
        initial_leads: "Leads no mês inicial",
        new_leads: "Novos leads",
        recommendation_leads: "Leads gerados por indicação",
        initial_clients: "Clientes no mês inicial",
        new_clients: "Novos clientes",
        lost_clients: "Clientes perdidos",
        initial_balance: "Saldo no mês inicial",
        mrr: "Receita Recorrente Mensal (MRR)",
        setup_revenue: "Receita de instalações (setup)",
        other_revenue: "Outras receitas",
        marketing_expenses: "Despesas comerciais: marketing",
        selling_expenses: "Despesa comerciais: vendas",
        other_expenses: "Outras despesas",
      },
    };
  },
  mounted() {
    this.groupedTasks = this.groupBy(this.tasks, "family");
  },
  watch: {
    tasks() {
      this.groupedTasks = this.groupBy(this.tasks, "family");
    },
  },
  methods: {
    groupBy(xs, key) {
      return xs.reduce(function (ac, task) {
        if (task.family && task.is_number)
          (ac[task[key]] = ac[task[key]] || []).push(task);
        return ac;
      }, {});
    },
  },
};
</script>
